export type AccentColor = 'primary' | 'success' | 'warning' | 'danger' | 'info' | 'violet';

export function getAccentIconClasses(color: AccentColor): string {
  const map: Record<AccentColor, string> = {
    primary: 'bg-[var(--color-primary-soft)]',
    success: 'bg-[var(--color-success-soft)]',
    warning: 'bg-[var(--color-warning-soft)]',
    danger: 'bg-[var(--color-danger-soft)]',
    info: 'bg-[var(--color-primary-soft)]',
    violet: 'bg-[var(--color-primary-soft)]',
  };
  return map[color] || map.primary;
}

export function getAccentIconColor(color: AccentColor): string {
  const map: Record<AccentColor, string> = {
    primary: 'var(--color-primary)',
    success: 'var(--color-success)',
    warning: 'var(--color-warning)',
    danger: 'var(--color-danger)',
    info: 'var(--color-info)',
    violet: 'var(--color-primary)',
  };
  return map[color] || map.primary;
}
